import axiosInstance from "./AxiosInstance";

export function getObjections(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("objections/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function addObjection(objectionData) {
  return axiosInstance.post("objections/add", objectionData);
}

export function updateObjection(objectionData) {
  return axiosInstance.post("objections/edit", {
    ...objectionData,
  });
}

export function deleteObjection(objectionId) {
  return axiosInstance.post("objections/delete", {
    objection_id: objectionId,
  });
}

export function formatObjections(responseData) {
  if (!responseData || !Array.isArray(responseData)) return [];

  return responseData.map((item) => ({
    objection_id: item.objection_id || item._id || item.id,

    // ✅ map backend → frontend fields
    objection_text: item.objection_text,
    is_active: item.objection_status === "Active" ? 1 : 0,

    created_at: item.created_at,
    updated_at: item.updated_at,
  }));
}
